import React from 'react';
import { graphql } from 'gatsby';
import { Container } from 'reactstrap';

import Layout from '../components/shared/layout';
import SEO from '../components/shared/seo';
import { ProductCardsComponent } from '../templates/product/ProductCardsComponent';

class IndexPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      NoOfPost: 6,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const lastScrollY = window.pageYOffset + 1100;

    if (lastScrollY > window.outerHeight) {
      const { NoOfPost } = this.state;
      const count = NoOfPost + 3;
      this.setState({
        NoOfPost: count,
      });
    }
  };

  render() {
    const { data } = this.props;
    const { NoOfPost } = this.state;
    const products = data.allContentfulProduct.edges
      .slice(0, NoOfPost)
      .map((product) => product.node);

    return (
      <>
        <SEO
          title="Tous nos produits"
          keywords={['locevent', 'essonne', '91', 'location', 'materiel', 'reception', 'mariage', 'store']}
        />
        <Container style={{ margin: '1em auto' }}>
          <div className="text-center">
            <h2 className="with-underline">
              Tous nos produits
            </h2>
          </div>
          <div className="text-center">
            <div>
              Voici tous nos produits proposés à la location.
              <br />
              Affinez votre recherche en cliquant sur les catégories dans le menu.
            </div>
          </div>
          {
            products
              ? <ProductCardsComponent products={products} large={3} medium={4} />
              : <div>Aucun produit.</div>
          }
        </Container>
      </>
    );
  }
}

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Store" keywords={['locevent', 'essonne', '91', 'location', 'materiel', 'reception', 'mariage']} />
    <div className="container store-page">
      <IndexPost data={data} />
    </div>
  </Layout>
);

export default IndexPage;

export const query = graphql`
  query StoreQuery {
    allContentfulProduct{
      edges{
        node{
          id
          name
          id
          name
          slug
          rating
          price
          conditionnement
          categories {
            title {
              title
            }
            slug
            description {
              childMarkdownRemark {
                html
              }
            }
          }
          image {
            fixed(width: 1000, height: 500) {
              width
              height
              src
              srcSet
            }
            file {
              url
            }
          }
          details {
            childMarkdownRemark {
              excerpt(pruneLength: 140)
            }
          }
          declinaisons {
            name
            value
            price
            type
            images {
              id
              file {
                url
              }
            }
          }
        }
      }
    }
  }
`;
